import { Component, effect, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import {
  ApplicantAppEntityApplicationRead, ApplicantAppEntityShipmentRead,
  ShipmentAppEntityShipmentRead
} from '../../../openapi';
import { Store } from '@ngrx/store';
import { loadShipment } from '../../../store/actions/application.actions';
import { ActivatedRoute, RouterModule } from '@angular/router';
import {
  selectLoading,
  selectPending,
  selectShipment
} from '../../../store/selectors/application.selectors';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { LabelComponent } from '../../../common/label/label.component';
import { dateToPLString } from '../../../services/helpers';
import { ReactiveFormsModule } from '@angular/forms';
import { PayerForm } from './payer.form';
import { ValidationErrorsComponent } from '../../../common/validation-errors/validation-errors.component';
import { PaymentCommonService } from '../../../services/payment.common.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-application-payment-page',
  standalone: true,
  imports: [
    CommonModule,
    ContentComponent,
    BreadcrumbsComponent,
    SpinnerComponent,
    LabelComponent,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    RouterModule
  ],
  providers: [PayerForm],
  templateUrl: './application-payment-page.component.html'
})
export class ApplicationPaymentPageComponent implements OnInit {

  public shipmentId: string | undefined =
    this.route.snapshot.params['shipmentId'];

  public shipment: Signal<ShipmentAppEntityShipmentRead | null>
    = this.store$.selectSignal(selectShipment);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public payers: ApplicantAppEntityShipmentRead[] = [];

  public get goBackPath(): string {
    return `../../wnioski-zatwierdzone${this.shipment()?.sourceApplication?.service?.url}/${this.shipment()?.sourceApplication?.uuid}`;
  }

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private paymentCommonService: PaymentCommonService,
    public form: PayerForm
  ) {
    effect(() => {
      const shipment: ShipmentAppEntityShipmentRead | null = this.shipment();
      if (shipment) {
        this.form.serviceName.setValue(shipment?.sourceApplication?.service?.name || '');
        this.form.paymentTitle.setValue(`Opłata za decyzję z dnia ${dateToPLString(new Date()) || ''} do wniosku nr. ${shipment?.sourceApplication?.uuid}`);
        this.form.decision.setValue(this.shipmentId);
        this.payers = shipment?.sourceApplication?.applicants || [];
        this.form.payer.setValue(this.payers[0] || null);

        const totalAmount = shipment?.amount || 0;
        this.form.totalAmount.setValue(totalAmount.toFixed(2).replace('.', ','));
      }
    });
  }

  public onSubmit(): void {
    if (this.form.valid) {
      this.paymentCommonService.goToPay({
        ...this.form.toWriteModel(),
        returnUrl: `${environment.ssl ? 'https' : 'http'}://${window.location.host}/wnioski-zatwierdzone${this.shipment()?.sourceApplication?.service?.url}/${this.shipment()?.sourceApplication?.uuid}`
      }).toPromise().then();
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnInit(): void {
    if (this.shipmentId) {
      this.store$.dispatch(loadShipment({ id: this.shipmentId || '' }));
    }
  }
}
